import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
Vue.config.productionTip = false;
import "./assets/icons"; // icon

import "./assets/css/common.less";
import "./assets/css/common.css";
import "./assets/css/theme/dark.css";
import "./assets/css/theme/light.css";

Vue.config.ignoredElements = ["wx-open-launch-app"];
import { MessagePlugin } from "tdesign-vue";
// 引入组件库的少量全局样式变量
import "tdesign-vue/es/style/index.css";

Vue.use(MessagePlugin);
import unityBridge from "./utils/unityBridge";

Vue.prototype.$unity = unityBridge;
import "./utils/rem"; // 引入rem适配
let vueDom = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default vueDom;
